<template>
	<div class="fc-cart" v-click-outside="hideCartList">
		<a @click="showCart = !showCart">{{ cartsProducts.length }}<span class="fc-mobile-hide">(${{ items.SubTotal | price }})</span></a>
		<div class="fc-cart-products-list" v-if="showCart && items.CartsProducts.length > 0">
			<div class="fc-deliver-price" v-if="items.DeliveryType == 1">
        <span v-if="items.SubTotal < items.MinimumPurchaseForDelivery">${{ (items.MinimumPurchaseForDelivery - items.SubTotal) | price }} more for delivery</span>
        <span v-else-if="items.SubTotal < items.FreeDeliveryPurchaseAmount">${{ (items.FreeDeliveryPurchaseAmount - items.SubTotal) | price }} more for <b>FREE</b> delivery</span>
        <span v-else>You got yourself <b>FREE</b> delivery!</span>
        <div class="fc-proress">
          <div :class="{'fc-full': items.FreeDeliveryPurchaseAmount < items.SubTotal}" :style="{'width': statusPercent}"></div>
        </div>
			</div>
      <div class="fc-self-pickup" v-if="items.DeliveryType == 0">
        <label>PICKUP OUTLET:</label>
        <span>{{ items.OutletName }}</span>
      </div>
			<div class="fc-deliver-address" v-if="items.DeliveryType == -1">
				<label>DELIVERY ADDRESS:</label>
				<span>{{ items.DeliveryAddress }}</span>
			</div>
			<div class="fc-cart-products">
				<ul>
					<li v-for="product in cartsProducts">
						<div>
							<span>{{ product.Qty }}x</span>
              <span v-if="product.BoxName != null && product.BoxName != ''">{{ product.ProductName }} - {{ product.BoxName }}</span>
							<span v-else>{{ product.ProductName }}</span>
							<span>$ {{ product.SubTotal | price }}</span>
							<a @click='remove(product)'></a>
						</div>
					</li>
				</ul>
			</div>
			<div class="fc-cart-checkout">
				<div>
					SUBTOTAL: ${{ items.SubTotal | price }}
				</div>
				<div>
					<a v-bind:class="{ 'fc-active': enableCheckout }" v-bind:disabled="!enableCheckout" @click="toCartDetail">GO TO CART</a>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapFields, mapMultiRowFields } from 'vuex-map-fields'
import ClickOutside from 'vue-click-outside'
import $ from 'jquery'
export default {
  name: 'cart',
  data () {
    return {
      showCart: false
    }
  },
  created () {
    this.$store.dispatch('cart/getCarts')
  },
  methods: {
    toCartDetail () {
      this.showCart = false
      this.$router.push({path: this.RouterConfig.CartDetail})
    },
    hideCartList () {
      this.showCart = false
    },
    remove (product) {
      if (process.browser) {
        const _this = this
        $.confirm({
          title: 'Warning',
          content: 'Remove this item?',
          type: 'orange',
          useBootstrap: false,
          buttons: {
            tryAgain: {
              text: 'OK',
              action: function () {
                _this.$store.dispatch('cart/removeCartProduct', product)
              }
            },
            close: function () {
            }
          }
        })
      }
    }
  },
  computed: {
    ...mapFields('cart', [
      'items'
    ]),
    ...mapMultiRowFields('cart',
      {
        cartsProducts: 'items.CartsProducts'
      }
    ),
    statusPercent () {
      if (this.items.SubTotal < this.items.MinimumPurchaseForDelivery) {
        return ((this.items.SubTotal / this.items.MinimumPurchaseForDelivery) * 100).toString() + '%'
      } else if (this.items.SubTotal < this.items.FreeDeliveryPurchaseAmount) {
        return ((this.items.SubTotal / this.items.FreeDeliveryPurchaseAmount) * 100).toString() + '%'
      } else {
        return '100%'
      }
    },
    enableCheckout () {
      return this.items.SubTotal >= this.items.MinimumPurchaseForDelivery || this.items.DeliveryType === 0
    }
  },
  directives: {
    ClickOutside
  }
}
</script>


// WEBPACK FOOTER //
// src/components/checkout/Cart.vue